module.exports = __webpack_public_path__ + "static/media/free_code_camp.e6a1f97f.png";